import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.checkInResponse.DOC}
  query CheckInResponses(
    $tenantId: ID!
    $zoneId: ID!
    $from: [ID!]
    $quantity: Int
    $skip: Int
    $submittedBefore: AWSDate
    $submittedAfter: AWSDate
    $submittedNotBefore: AWSDate
    $submittedNotAfter: AWSDate
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        checkInResponses(
          from: $from
          quantity: $quantity
          skip: $skip
          submittedBefore: $submittedBefore
          submittedAfter: $submittedAfter
          submittedNotBefore: $submittedNotBefore
          submittedNotAfter: $submittedNotAfter
        ) {
          ...FragmentCheckInResponse
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.CheckInResponsesQuery,
    readonly ents.core.summit.CheckIn.Response[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'checkInResponses',
        graphql.transformers.OUT.list(fragments.checkInResponse.TRANSFORMER, {
          onNullish: 'remove',
        }),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.CheckInResponsesQuery,
  readonly ents.core.summit.CheckIn.Response[],
  graphql.schema.CheckInResponsesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
